import React, { useContext } from "react";
import styles from "./TimelineSection.module.scss";

import SectionWrapper from "../../elements/SectionWrapper";
import Timeline from "../../elements/Timeline/Timeline";
import { LoggerContext } from "context/LoggerContext";

const TimelineSection = (props) => {
    const { logDebug } = useContext(LoggerContext);
    const { alignment, cta_text, cta_link, data } = props;
    logDebug("TimelineSection props:", props);
    logDebug("TimelineSection data structure:", data);
    
    // Extrahiere die Agenda-Daten, aber prüfe zuerst die Struktur
    // Wir benötigen ein Array für die Timeline-Komponente
    // let timelineEvents = null;
    
    // if (data && data[0] && data[0].list && data[0].list[0] && data[0].list[0].agendas) {
    //     timelineEvents = data[0].list[0].agendas;
    //     console.log("Timeline events found:", timelineEvents);
    // } else {
    //     console.warn("Timeline events missing or invalid data structure:", data);
    // }
    return (
        <div className={`text-${alignment ? alignment : "left"}`}>
            <SectionWrapper 
                className={`${styles.TimelineSection}`} 
                fluid={false} 
                {...props}
            >
                {data && data.length > 0 ? (
                    <Timeline 
                        events={data}
                        alignment={alignment}
                    />
                ) : (
                    <div className="alert alert-info">Keine Timeline-Daten verfügbar.</div>
                )}
                {cta_text && cta_link && (
                    <a href={cta_link} className="btn btn-primary mt-3">
                        {cta_text}
                    </a>
                )}
            </SectionWrapper>
        </div>
	);
};

export default TimelineSection;
